// extracted by mini-css-extract-plugin
module.exports = {"swiper":"HeroCards_swiper__97G8O"};